<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row>
                <v-col cols="3" class="text-right">
                    <v-select
                        :items="filters"
                        v-model="filter.scrap_packing_no"
                        item-text="scrap_packing_no"
                        item-value="scrap_packing_no"
                        menu-props="auto"
                        label="Scrap Packing No."
                        @change="get_data()"
                    ></v-select>
                </v-col>
            </v-row>

            <v-row v-if="filter.scrap_packing_no != ''">
                <v-col cols="4">
                    <h2>
                        {{ filter.scrap_packing_no }}
                    </h2>
                </v-col>
                <v-col cols="4">
                    <h3>
                        Sent Scrap By : {{ data_scrap.scrap_name }} (
                        {{ data_scrap.scrap_date }} )
                    </h3>
                </v-col>
                <v-col cols="4" class="text-right">
                    <v-btn
                        class="ml-3"
                        small
                        :loading="loading_export"
                        rounded
                        color="success"
                        @click="export_data_scrap()"
                    >
                        <v-icon small>mdi-download</v-icon>
                        Export Data
                    </v-btn>
                </v-col>
                <v-col cols="7">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center">
                                        #
                                    </th>
                                    <th class="text-center">
                                        Case
                                    </th>
                                    <th class="text-center">
                                        S/N
                                    </th>
                                    <th class="text-center">
                                        Scrap No
                                    </th>
                                    <th class="text-center">
                                        Box Size
                                    </th>
                                    <th class="text-center">
                                        Weight
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    v-for="(row, index) in data_main"
                                    :key="index"
                                    :class="
                                        row.status == 'Request'
                                            ? 'amber lighten-3'
                                            : ''
                                    "
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td>
                                        <span class="font-b primary--text">
                                            {{ row.case_id }}
                                        </span>
                                        <v-btn
                                            class="ml-2"
                                            dark
                                            :to="
                                                '/Project/ViewCasepending/' +
                                                    team_name +
                                                    '/' +
                                                    row.maincase_id +
                                                    '/ViewDetail'
                                            "
                                            target="_blank"
                                            x-small
                                            fab
                                            color="orange"
                                            elevation="1"
                                        >
                                            <v-icon small>mdi-magnify</v-icon>
                                        </v-btn>
                                        <br />
                                        <span class="font-b">
                                            {{ row.product_no }}
                                        </span>
                                        {{ row.product_description }}
                                    </td>
                                    <td>{{ row.serial }}</td>
                                    <td class="text-center">
                                        <span class="font-b primary--text">
                                            {{ row.branch_name }}
                                        </span>
                                        <br />
                                        {{ row.scrap_no }}
                                    </td>
                                    <td class="text-center">
                                        {{ row.box_size }}
                                    </td>
                                    <td class="text-right">
                                        {{ row.weight }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols="5">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center">
                                        #
                                    </th>
                                    <th class="text-center">
                                        Detail
                                    </th>
                                    <th class="text-center">
                                        Part No
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row, index) in data_sub"
                                    :key="index"
                                    :class="
                                        row.return_remark == 'Request'
                                            ? 'amber lighten-3'
                                            : ''
                                    "
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td>
                                        <span class="font-b primary--text">
                                            {{ row.branch_name }}
                                        </span>
                                        <br />
                                        <span class="font-b">
                                            {{ row.case_id }}
                                        </span>
                                        {{ row.site_name }}
                                    </td>
                                    <td>
                                        <span class="font-b">
                                            {{ row.part_name }}
                                        </span>
                                        {{ row.part_description }}
                                    </td>
                                </tr>
                                <br />
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    watch: {},
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_filter()
    },
    methods: {
        async get_filter() {
            this.filters = []
            this.dialog_loading = true
            await axios
                .get(url + "scrap/history", this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.filters = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data() {
            this.data_main = []
            this.data_sub = []
            this.data_scrap = {}
            this.dialog_loading = true
            await axios
                .get(
                    url + "scrap/history/" + this.filter.scrap_packing_no,
                    this.tk
                )
                .then((response) => {
                    this.dialog_loading = false
                    this.data_main = response.data.units
                    this.data_sub = response.data.parts
                    this.data_scrap = response.data.detail
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async export_data_scrap() {
            this.loading_export = true

            await axios({
                url: url + "scrap/export/" + this.filter.scrap_packing_no,
                method: "GET",
                responseType: "blob",
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.loading_export = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "export.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
    },

    data() {
        return {
            filters: [],
            data_scrap: {},
            data_main: [],
            data_sub: [],
            dialog_loading: false,
            filter: {
                scrap_packing_no: "",
            },
            loading_export: false,
        }
    },
}
</script>
